(function (window, document) {
  'use strict';

  function parseJson(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function normalize(value) {
    return String(value || '').trim().toLocaleLowerCase();
  }

  function unique(values) {
    return values.filter(function (value, index) {
      return value !== undefined && value !== null && values.indexOf(value) === index;
    });
  }

  function optionHandle(value) {
    return String(value || '').trim().toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function optionIndex(options, names) {
    var wanted = names.map(normalize);
    return options.findIndex(function (name) {
      return wanted.indexOf(normalize(name)) !== -1;
    });
  }

  function setResponsiveImage(image, src, srcset) {
    if (!image) return;
    if (src) image.src = src;
    else image.removeAttribute('src');
    if (srcset) image.srcset = srcset;
    else image.removeAttribute('srcset');
  }

  // Warms the theme's quick view cache (`sessionStorage['qv' + id]`) on hover or
  // press only, using the exact URL geckoShopify.initQuickView would request.
  function prefetchQuickView(link) {
    if (!link || window.sp_nt_storage !== true) return;
    if (link.__scrubzQvPrefetch) return;

    var id = link.getAttribute('data-id');
    var href = link.getAttribute('href');
    if (!id || !href) return;

    try {
      if (window.sessionStorage.getItem('qv' + id)) return;
    } catch (error) {
      return;
    }

    link.__scrubzQvPrefetch = true;
    var separator = href.indexOf('?variant=') >= 0 ? '&' : '/?';

    window.fetch(href + separator + 'view=quick_view', { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.text() : null;
      })
      .then(function (html) {
        if (!html) return;
        try {
          window.sessionStorage.setItem('qv' + id, html);
        } catch (error) {
          // The theme falls back to its own request when storage is full.
        }
      })
      .catch(function () {
        // Prefetch is best effort; the theme fetches on click when it misses.
      })
      .then(function () {
        link.__scrubzQvPrefetch = false;
      });
  }

  function initialize($) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-scrubz-wear-it-with]'), function (root) {
      if (root.getAttribute('data-wiw-initialized') === 'true') return;
      root.setAttribute('data-wiw-initialized', 'true');

      var colorNames = parseJson(root.getAttribute('data-color-option-names'), ['color', 'colors', 'couleur', 'colour']);
      var sizeNames = parseJson(root.getAttribute('data-size-option-names'), ['size', 'sizes', 'größe']);
      var mainNames = parseJson(root.getAttribute('data-main-option-names'), []);
      var mainVariants = parseJson(root.getAttribute('data-main-variants'), []);
      var mainColorIndex = optionIndex(mainNames, colorNames);
      var mainSelector = document.querySelector(root.getAttribute('data-main-selector'));
      var mainColor = readMainColor();
      var cards = [];

      Array.prototype.forEach.call(root.querySelectorAll('[data-wiw-card]'), function (element) {
        var data = parseJson(element.getAttribute('data-product-json'), null);
        if (!data || !Array.isArray(data.options) || !Array.isArray(data.variants) || !data.variants.length) return;

        data.variants = data.variants.map(function (variant) {
          variant.options = Array.isArray(variant.options) ? variant.options : [];
          return variant;
        });

        var available = data.variants.filter(function (variant) {
          return variant.available === true && variant.options.length === data.options.length;
        });
        var item = {
          element: element,
          data: data,
          colorIndex: optionIndex(data.options, colorNames),
          sizeIndex: optionIndex(data.options, sizeNames),
          available: available,
          allVariants: data.variants,
          selected: [],
          controls: [],
          controlsHost: element.querySelector('[data-wiw-controls]'),
          image: element.querySelector('[data-wiw-image]'),
          price: element.querySelector('[data-wiw-price]'),
          button: element.querySelector('[data-wiw-add]'),
          buttonLabel: element.querySelector('[data-wiw-add-label]'),
          message: element.querySelector('[data-wiw-message]'),
          busy: false
        };

        if (!item.controlsHost || !item.button) {
          return;
        }

        var preferredVariant = null;
        if (mainColor !== null && item.colorIndex >= 0) {
          preferredVariant = available.find(function (variant) {
            return variant.options[item.colorIndex] === mainColor;
          }) || null;
        }
        preferredVariant = preferredVariant || available[0];
        item.selected = preferredVariant ? preferredVariant.options.slice() : [];

        data.options.map(function (name, index) {
          var isDefaultTitle = normalize(name) === 'title' && data.variants.every(function (variant) {
            return normalize(variant.options[index]) === 'default title';
          });
          if (isDefaultTitle) return null;
          var kind = index === item.colorIndex ? 'color' : (index === item.sizeIndex ? 'size' : 'other');
          return { index: index, name: name, kind: kind, element: null, choices: [], displayChoices: [] };
        }).filter(function (control) {
          return control !== null;
        }).sort(function (a, b) {
          var rank = { color: 0, size: 1, other: 2 };
          return rank[a.kind] - rank[b.kind] || a.index - b.index;
        }).forEach(function (control) {
          item.controls.push(control);
          renderControl(item, control);
        });

        refreshOptions(item);
        updateCard(item);
        cards.push(item);
      });

      function readMainColor() {
        if (mainColorIndex < 0) return null;
        var selectedId = mainSelector && mainSelector.value;
        if (!selectedId) selectedId = root.getAttribute('data-main-selected-variant');
        var variant = mainVariants.find(function (candidate) {
          return String(candidate.id) === String(selectedId);
        });
        return variant && Array.isArray(variant.options) ? variant.options[mainColorIndex] : null;
      }

      $(root).on('click.scrubzWearItWith', '[data-wiw-value]', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var card = this.closest('[data-wiw-card]');
        var item = cards.find(function (candidate) { return candidate.element === card; });
        if (!item) return;
        var index = Number(this.getAttribute('data-wiw-option-index'));
        var control = item.controls.find(function (candidate) { return candidate.index === index; });
        if (!control || control.choices.indexOf(this.getAttribute('data-wiw-value')) < 0) return;
        item.selected[index] = this.getAttribute('data-wiw-value');
        clearMessage(item);
        refreshOptions(item);
        updateCard(item);
      });

      $(root).on('keydown.scrubzWearItWith', '[data-wiw-value][role="radio"]', function (event) {
        var key = event.key;
        if (key !== 'Enter' && key !== ' ' && key !== 'ArrowLeft' && key !== 'ArrowRight') return;
        event.preventDefault();
        var radios = Array.prototype.slice.call(this.parentNode.querySelectorAll('[data-wiw-value][role="radio"]'));
        if (key === 'ArrowLeft' || key === 'ArrowRight') {
          var nextIndex = radios.indexOf(this) + (key === 'ArrowRight' ? 1 : -1);
          if (nextIndex < 0) nextIndex = radios.length - 1;
          if (nextIndex >= radios.length) nextIndex = 0;
          if (radios[nextIndex]) radios[nextIndex].focus();
        } else {
          this.click();
        }
      });

      $(root).on('change.scrubzWearItWith', '[data-wiw-select]', function () {
        var card = this.closest('[data-wiw-card]');
        var item = cards.find(function (candidate) { return candidate.element === card; });
        if (!item) return;
        var index = Number(this.getAttribute('data-wiw-option-index'));
        item.selected[index] = this.value;
        clearMessage(item);
        refreshOptions(item);
        updateCard(item);
      });

      $(root).on('click.scrubzWearItWith', '[data-wiw-add]', function () {
        var button = this;
        var item = cards.find(function (candidate) { return candidate.button === button; });
        if (!item || item.busy) return;
        var variant = exactVariant(item);
        if (!variant || variant.available !== true) {
          showMessage(item, 'Please choose an available option combination.');
          updateCard(item);
          return;
        }
        addToCart(root, item, variant);
      });

      $(root).on('click.scrubzWearItWith', '[data-wiw-browse]', function () {
        $('body').addClass('scrubz-wear-it-with-qv-active');
      });

      $(root).on('mouseenter.scrubzWearItWith', '[data-wiw-browse]', function () {
        prefetchQuickView(this);
      });

      $(root).on('pointerdown.scrubzWearItWith', '[data-wiw-browse]', function () {
        prefetchQuickView(this);
      });

      $(document).off('mfpClose.scrubzWearItWith').on('mfpClose.scrubzWearItWith', function () {
        $('body').removeClass('scrubz-wear-it-with-qv-active');
      });
    });

    function renderControl(item, control) {
      var wrapper = document.createElement('div');
      wrapper.className = 'scrubz-wear-it-with__control scrubz-wear-it-with__control--' + control.kind;
      var label = document.createElement('span');
      label.className = 'scrubz-wear-it-with__control-label';
      label.textContent = control.kind === 'color' ? 'Color' : control.name;
      wrapper.appendChild(label);

      if (control.kind === 'other') {
        var select = document.createElement('select');
        select.className = 'scrubz-wear-it-with__select';
        select.setAttribute('data-wiw-select', '');
        select.setAttribute('data-wiw-option-index', String(control.index));
        select.setAttribute('aria-label', control.name + ' for ' + item.data.title);
        wrapper.appendChild(select);
        control.element = select;
      } else {
        var choices = document.createElement(control.kind === 'color' ? 'ul' : 'div');
        choices.className = 'scrubz-wear-it-with__choices scrubz-wear-it-with__choices--' + control.kind;
        if (control.kind === 'color') choices.classList.add('swatches-select', 'swatch__list_pr');
        choices.setAttribute('role', control.kind === 'color' ? 'radiogroup' : 'group');
        choices.setAttribute('aria-label', control.name + ' for ' + item.data.title);
        wrapper.appendChild(choices);
        control.element = choices;
      }
      control.choices = [];
      item.controlsHost.appendChild(wrapper);
    }

    function valuesFor(item, control, onlyAvailable) {
      var variants = (onlyAvailable ? item.available : item.allVariants).filter(function (variant) {
        if (control.kind === 'color') return true;
        return item.selected.every(function (value, index) {
          return index === control.index || value === undefined || value === null || variant.options[index] === value;
        });
      });
      return unique(variants.map(function (variant) { return variant.options[control.index]; }));
    }

    function refreshOptions(item) {
      var changed = true;
      var passes = item.controls.length * 2 + 2;
      while (changed && passes > 0) {
        changed = false;
        passes -= 1;
        item.controls.forEach(function (control) {
          var choices = valuesFor(item, control, true);
          var displayChoices = control.kind === 'color' ? choices : valuesFor(item, control, false);
          var current = item.selected[control.index];
          var next = choices.indexOf(current) >= 0 ? current : (choices[0] === undefined ? null : choices[0]);
          if (current !== next) {
            item.selected[control.index] = next;
            changed = true;
          }
          control.choices = choices;
          control.displayChoices = displayChoices;
          paintControl(item, control);
        });
      }
      item.controls.forEach(function (control) { paintControl(item, control); });
    }

    function paintControl(item, control) {
      var host = control.element;
      if (!host) return;
      if (control.kind === 'other') {
        while (host.options.length) host.remove(0);
        control.displayChoices.forEach(function (value) {
          var option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          option.disabled = control.choices.indexOf(value) < 0;
          host.appendChild(option);
        });
        host.value = item.selected[control.index] || '';
        host.disabled = control.displayChoices.length <= 1;
        return;
      }

      while (host.firstChild) host.removeChild(host.firstChild);
      control.displayChoices.forEach(function (value, choiceIndex) {
        if (control.kind === 'color') {
          var colorVariant = item.allVariants.find(function (variant) {
            return variant.options[control.index] === value;
          });
          var colorHandle = colorVariant && colorVariant.colorHandle ? colorVariant.colorHandle : optionHandle(value);
          var swatch = document.createElement('li');
          swatch.className = 'ttip_nt tooltip_top nt-swatch swatch_pr_item bg_css_' + colorHandle + ' scrubz-wear-it-with__choice scrubz-wear-it-with__choice--color';
          swatch.setAttribute('data-index', String(choiceIndex));
          swatch.setAttribute('data-value', colorHandle);
          swatch.setAttribute('data-escape', value);
          swatch.setAttribute('data-wiw-value', value);
          swatch.setAttribute('data-wiw-option-index', String(control.index));
          swatch.setAttribute('role', 'radio');
          swatch.setAttribute('aria-label', value);
          swatch.setAttribute('aria-checked', String(item.selected[control.index] === value));
          swatch.setAttribute('tabindex', item.selected[control.index] === value ? '0' : '-1');
          if (item.selected[control.index] === value) swatch.classList.add('is-selected');
          var tooltip = document.createElement('span');
          tooltip.className = 'tt_txt';
          tooltip.textContent = value;
          var swatchValue = document.createElement('span');
          swatchValue.className = 'swatch__value_pr pr bg_color_' + colorHandle + ' lazyloaded';
          swatchValue.setAttribute('aria-hidden', 'true');
          swatch.appendChild(tooltip);
          swatch.appendChild(swatchValue);
          host.appendChild(swatch);
        } else {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'scrubz-wear-it-with__choice scrubz-wear-it-with__choice--' + control.kind;
          button.setAttribute('data-wiw-value', value);
          button.setAttribute('data-wiw-option-index', String(control.index));
          button.setAttribute('aria-pressed', String(item.selected[control.index] === value));
          button.disabled = control.choices.indexOf(value) < 0;
          button.textContent = value;
          host.appendChild(button);
        }
      });
      host.setAttribute('aria-disabled', String(control.displayChoices.length <= 1));
    }

    function exactVariant(item) {
      if (item.selected.length !== item.data.options.length || item.selected.some(function (value) { return !value; })) return null;
      return item.available.find(function (variant) {
        return variant.options.length === item.selected.length && variant.options.every(function (value, index) {
          return value === item.selected[index];
        });
      }) || null;
    }

    function updateCard(item) {
      var variant = exactVariant(item);
      if (item.price) item.price.textContent = variant ? variant.formattedPrice : 'Unavailable';
      var imageSource = variant && variant.image ? variant.image : item.data.featuredImage;
      var imageSrcset = variant && variant.image ? variant.imageSrcset : item.data.featuredImageSrcset;
      setResponsiveImage(item.image, imageSource, imageSrcset);
      if (item.button) item.button.disabled = item.busy || !variant || variant.available !== true;
      if (item.buttonLabel && !item.busy) item.buttonLabel.textContent = 'Add to Cart';
    }

    function clearMessage(item) {
      if (!item.message) return;
      item.message.textContent = '';
      item.message.hidden = true;
    }

    function showMessage(item, text) {
      if (!item.message) return;
      item.message.textContent = text;
      item.message.hidden = false;
    }

    function addToCart(root, item, variant) {
      item.busy = true;
      item.button.disabled = true;
      item.button.setAttribute('aria-busy', 'true');
      if (item.buttonLabel) item.buttonLabel.textContent = 'Adding…';
      clearMessage(item);

      window.fetch(root.getAttribute('data-cart-add-url'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      }).then(function (response) {
        return response.text().then(function (body) {
          var result = parseJson(body, {});
          if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item to your cart.');
          return result;
        });
      }).then(function () {
        showMessage(item, 'Added to cart.');
        if (window.geckoShopify && typeof window.geckoShopify.onCartUpdate === 'function') {
          try {
            window.geckoShopify.onCartUpdate(0, 1, item.data.id);
          } catch (error) {
            // The item is already added if the optional theme refresh hook is unavailable.
          }
        }
        var themeJQuery = window.jQuery_T4NT;
        if (themeJQuery && !themeJQuery('body').hasClass('pside_opened')) {
          themeJQuery('.push_side[data-id="#nt_cart_canvas"]').first().trigger('click');
        }
      }).catch(function (error) {
        showMessage(item, error.message || 'Unable to add this item to your cart.');
      }).finally(function () {
        item.busy = false;
        if (item.button) item.button.removeAttribute('aria-busy');
        updateCard(item);
      });
    }
  }

  function waitForThemeJQuery(attempt) {
    var themeJQuery = window.jQuery_T4NT;
    if (themeJQuery) {
      themeJQuery(function ($) { initialize($); });
      return;
    }
    if (attempt < 60) window.setTimeout(function () { waitForThemeJQuery(attempt + 1); }, 50);
  }

  waitForThemeJQuery(0);
})(window, document);
